export const version = '0.786.0'
export const chameleonWebVersion = '9.13.0'
export const chameleonCoreVersion = '7.9.1'
